export enum PatientCaseType {
  PRESCRIPTION_REFILL = "prescription_refill",
}

export enum PatientCaseProviderRoutingStrategy {
  FIXED = "fixed",
  PREVIOUS_CASE_THEN_PRIMARY = "previous_case_then_primary",
}

export enum PatientCaseProviderResolutionSource {
  FIXED = "fixed",
  PREVIOUS_REFILL = "previous_refill",
  PRIMARY_PROVIDER = "primary_provider",
}

export enum PatientCaseErrorCode {
  PROVIDER_UNAVAILABLE = "patient_case_provider_unavailable",
}
